import loadingImg from "../../../assets/images/video-loading.gif";
import Vue from "vue";
import { MessageBox } from "element-ui";

const chiralConfirmLoading = function (msg, confirmButtonText, callback = "") {
  MessageBox.confirm("", msg, {
    center: true,
    showCancelButton: true,
    confirmButtonText: confirmButtonText,
    customClass: "confirm-btn",
    confirmButtonClass: "large-confirm-btn",
    cancelButtonClass: "large-confirm-btn",
    beforeClose: (action, instance, done) => {
      if (action === "confirm") {
        instance.confirmButtonLoading = true;
        done();
        setTimeout(() => {
          instance.confirmButtonLoading = false;
        }, 300);
      } else {
        done();
      }
    },
  })
    .then(() => {
      callback && callback(true);
    })
    .catch(() => {
      callback && callback(false);
    });
};

const chiralConfirmMessage = function (msg, callback = "") {
  MessageBox.confirm("", msg, {
    center: true,
    showCancelButton: false,
    confirmButtonText: "好的",
    customClass: "confirm-message",
    confirmButtonClass: "msg-btn",
  })
    .then(() => {
      callback && callback();
    })
    .catch(() => {
      callback && callback();
    });
};

const chiralAutoMessage = function (msg, setTime) {
  MessageBox.confirm(msg, "", {
    center: true,
    customClass: "auto-message",
    showCancelButton: false,
    showConfirmButton: false,
    dangerouslyUseHTMLString: true,
  });
  if (setTime) {
    setTimeout(() => {
      MessageBox.close(false); //重要
    }, setTime);
  }
};

const showDialog = (msg, callback = "") => {
  return MessageBox.confirm("", msg, {
    center: true,
    confirmButtonText: "确认",
    confirmButtonClass: "msg-btn",
    cancelButtonClass: "msg-btn",
  })
    .then(() => {
      callback && callback();
    })
    .catch(() => {});
};
const msgDialog = function (msg, callback = "") {
  MessageBox.confirm("", msg, {
    center: true,
    showCancelButton: false,
    confirmButtonText: "好的",
    confirmButtonClass: "msg-btn",
  })
    .then(() => {
      callback && callback();
    })
    .catch(() => {
      callback && callback();
    });
};

// 显示Toast
const showToast = function (message = "这是一个 Toast 提示") {
  const toast = document.createElement("div");
  toast.classList.add("moguo-toast");
  toast.textContent = message;
  setTimeout(() => {
    toast.classList.add("show");
    setTimeout(() => {
      toast.classList.remove("show");
      setTimeout(() => {
        toast.remove();
      }, 300);
    }, 1000); // 显示2秒后消失
  }, 100); // 延迟100毫秒显示，以便用户可以看到渐显效果
  document.body.appendChild(toast);
};

// 显示loading-gif
const showLoadingGif = () => {
  if (document.querySelector(".moguo-loading-gif")) {
    document.querySelector(".moguo-loading-gif").style.display = "block";
  } else {
    const loading = document.createElement("img");
    loading.classList.add("moguo-loading-gif");
    loading.src = loadingImg;
    document.body.appendChild(loading);
  }
};
const hideLoadingGif = () => {
  let loading = document.querySelector(".moguo-loading-gif");
  if (loading) {
    loading.style.display = "none";
  }
};

Vue.prototype.$chiralConfirmLoading = chiralConfirmLoading;
Vue.prototype.$chiralConfirmMessage = chiralConfirmMessage;
Vue.prototype.$chiralAutoMessage = chiralAutoMessage;
Vue.prototype.$showDialog = showDialog;
Vue.prototype.$msgDialog = msgDialog;
Vue.prototype.$showToast = showToast;
Vue.prototype.$showLoadingGif = showLoadingGif;
Vue.prototype.$hideLoadingGif = hideLoadingGif;
